export default __webpack_public_path__ + "static/media/branche-fmcg.4ed29440.png";